<div class="row">
  <div class="col-lg col-md col-xs col-xl col-sm w-100">
    <mat-card class="mat-elevation-z8 w-100">
      <form [formGroup]="formulario" (keydown.enter)="$event.preventDefault()">
        <div class="row">
          <div class="col-lg col-md col-xs col-xl col-sm">
            <p class="tituloLeft">{{step}}</p>
          </div>
          <div class="col-lg-2 col-md-2 col-xs-2 col-xl-2 col-sm-2 text-right">
            <i class="fa fa-window-minimize iconMenu" matTooltip="Minimizar" (click)="changeCollapse()"
              *ngIf="!collapseCard"></i>
            <i class="fa fa-window-maximize iconMenu" matTooltip="Maximizar" (click)="changeCollapse()"
              *ngIf="collapseCard"></i>
          </div>
        </div>
        <mat-card-content *ngIf="!collapseCard">
          <div class="row pt-3">
            <div class="col-lg col-md">
              <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Pump Station Calda Convencional</mat-label>
                <input matInput id="txtPumpStaCaldaConv" #txtPumpStaCaldaConv maxlength="10"
                  formControlName="pump_station_calda_convencional" currencyMask
                  [readOnly]="isReadOnlyCaldaConvencional" [class.InputBlockColor]="isReadOnlyCaldaConvencional"
                  [options]="{ thousands: '.', decimal: ',', precision: 0 }" (blur)="makeCalculations()">
                <i matSuffix class="{{iconEnableField}}" *ngIf="!isReadOnlyCaldaConvencional"></i>
                <i matSuffix class="{{iconDisableField}}" *ngIf="isReadOnlyCaldaConvencional"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}</mat-hint>
                <mat-hint align="end">{{txtPumpStaCaldaConv.value.length}} / 10</mat-hint>
                <mat-error>{{hasErrorFormControl(formulario.controls.pump_station_calda_convencional)}}
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col-lg col-md">
              <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Pump Station Calda TSI</mat-label>
                <input matInput id="txtPumpStaCaldaTSI" #txtPumpStaCaldaTSI maxlength="10"
                  formControlName="pump_station_calda_tsi" currencyMask [readOnly]="isReadOnlyTSI"
                  [class.InputBlockColor]="isReadOnlyTSI" [options]="{ thousands: '.', decimal: ',', precision: 0 }">
                <i matSuffix class="{{iconEnableField}}" *ngIf="!isReadOnlyTSI"></i>
                <i matSuffix class="{{iconDisableField}}" *ngIf="isReadOnlyTSI"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}</mat-hint>
                <mat-hint align="end">{{txtPumpStaCaldaTSI.value.length}} / 10</mat-hint>
                <mat-error>{{hasErrorFormControl(formulario.controls.pump_station_calda_tsi)}}
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col-lg col-md">
              <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Pump Station Dermacor</mat-label>
                <input matInput id="txtPumpStaDermacor" #txtPumpStaDermacor maxlength="10"
                  formControlName="pump_station_dermacor" currencyMask [readOnly]="isReadOnlyDermacor"
                  [class.InputBlockColor]="isReadOnlyDermacor"
                  [options]="{ thousands: '.', decimal: ',', precision: 0 }" (blur)="makeCalculations()">
                <i matSuffix class="{{iconEnableField}}" *ngIf="!isReadOnlyDermacor"></i>
                <i matSuffix class="{{iconDisableField}}" *ngIf="isReadOnlyDermacor"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}</mat-hint>
                <mat-hint align="end">{{txtPumpStaDermacor.value.length}} / 10</mat-hint>
                <mat-error>{{hasErrorFormControl(formulario.controls.pump_station_dermacor)}}
                </mat-error>
              </mat-form-field>
            </div>
          </div>

          <div class="row pt-3">
            <div class="col-lg col-md">
              <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Pump Station Poncho</mat-label>
                <input matInput id="txtPumpStaPoncho2" #txtPumpStaPoncho2 maxlength="10"
                  formControlName="pump_station_poncho" currencyMask [readOnly]="isReadOnlyPoncho"
                  [class.InputBlockColor]="isReadOnlyPoncho" [options]="{ thousands: '.', decimal: ',', precision: 0 }"
                  (blur)="makeCalculations()">
                <i matSuffix class="{{iconEnableField}}" *ngIf="!isReadOnlyPoncho"></i>
                <i matSuffix class="{{iconDisableField}}" *ngIf="isReadOnlyPoncho"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}</mat-hint>
                <mat-hint align="end">{{txtPumpStaPoncho2.value.length}} / 10</mat-hint>
                <mat-error>{{hasErrorFormControl(formulario.controls.pump_station_poncho)}}
                </mat-error>
              </mat-form-field>
            </div>

            <!-- <div class="col-lg col-md">
                        <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                            floatLabel="{{formFieldFloatLabel}}">
                            <mat-label class="InputLabelColor">Pump Station Cruiser</mat-label>
                            <input matInput id="txtPumpStaCruiser" #txtPumpStaCruiser maxlength="10"
                                formControlName="pump_station_cruiser" currencyMask
                                [readOnly]="isReadOnlyCruiser" [class.InputBlockColor]="isReadOnlyCruiser"
                                [options]="{ thousands: '.', decimal: ',', precision: 0 }"
                                (blur)="makeCalculations()">
                              <i matSuffix class="{{iconEnableField}}" *ngIf="!isReadOnlyCruiser"></i>
                              <i matSuffix class="{{iconDisableField}}" *ngIf="isReadOnlyCruiser"></i>
                            <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}</mat-hint>
                            <mat-hint align="end">{{txtPumpStaCruiser.value.length}} / 10</mat-hint>
                            <mat-error>{{hasErrorFormControl(formulario.controls.pump_station_cruiser)}}
                            </mat-error>
                        </mat-form-field>
                      </div> -->
            <div class="col-lg col-md-6">
              <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Pump Station Redigo</mat-label>
                <input matInput id="txtPumpStaRedigo" #txtPumpStaRedigo maxlength="10"
                  formControlName="pump_station_redigo" currencyMask [readOnly]="isReadOnlyRedigo"
                  [class.InputBlockColor]="isReadOnlyRedigo" [options]="{ thousands: '.', decimal: ',', precision: 0 }"
                  (blur)="makeCalculations()">
                <i matSuffix class="{{iconEnableField}}" *ngIf="!isReadOnlyRedigo"></i>
                <i matSuffix class="{{iconDisableField}}" *ngIf="isReadOnlyRedigo"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}</mat-hint>
                <mat-hint align="end">{{txtPumpStaRedigo.value.length}} / 10</mat-hint>
                <mat-error>{{hasErrorFormControl(formulario.controls.pump_station_redigo)}}
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col-lg col-md">
              <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Talkum Gloss (g)</mat-label>
                <input matInput id="txtTalkumGloss" #txtTalkumGloss maxlength="10" formControlName="talkum_gloss"
                  currencyMask [options]="{ thousands: '.', decimal: ',', precision: 2 }" (blur)="makeCalculationsII()">
                <i matSuffix class="{{iconEnableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}</mat-hint>
                <mat-hint align="end">{{txtTalkumGloss.value.length}} / 10</mat-hint>
                <mat-error>{{hasErrorFormControl(formulario.controls.talkum_gloss)}}
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col-lg col-md">
              <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Correção Limpeza de Linha (%)</mat-label>
                <input matInput id="txtCorrecaoLimpezaLinha" #txtCorrecaoLimpezaLinha maxlength="10" [min]="0" [max]="5"
                  formControlName="correcao_limpeza_linha" currencyMask
                  [options]="{ thousands: '.', decimal: ',', precision: 1 }" (blur)="makeCalculationsII()"
                  [class.InputBlockColor]="isReadOnlyLotePos" [readonly]="isReadOnlyLotePos"
                  (keyup)="verifyFormValuesMaxMin($event)" (keypress)="verifyFormValuesMaxMin($event)">
                <i matSuffix class="{{iconEnableField}}" *ngIf="!isReadOnlyLotePos"></i>
                <i matSuffix class="{{iconDisableField}}" *ngIf="isReadOnlyLotePos"></i>
                <mat-hint align="end">{{txtCorrecaoLimpezaLinha.value.length}} / 10</mat-hint>
                <mat-error>{{hasErrorFormControl(formulario.controls.correcao_limpeza_linha)}}
                </mat-error>
              </mat-form-field>
            </div>
          </div>

          <div class="row pt-3">

            <div class="col-lg col-md">
              <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Ingrediente Ativo Laudo - Poncho</mat-label>
                <input matInput id="txtIngredienteAtivoLaudoPoncho" #txtIngredienteAtivoLaudoPoncho maxlength="10"
                  [min]="580" [max]="620" formControlName="ingrediente_ativo_laudo_produto_poncho" currencyMask
                  [options]="{ thousands: '.', decimal: ',', precision: 1 }" (blur)="makeCalculationsII()"
                  [class.InputBlockColor]="isReadOnlyPoncho" [readonly]="isReadOnlyPoncho">
                <i matSuffix class="{{iconEnableField}}" *ngIf="!isReadOnlyPoncho"></i>
                <i matSuffix class="{{iconDisableField}}" *ngIf="isReadOnlyPoncho"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}</mat-hint>
                <mat-hint align="end">{{txtIngredienteAtivoLaudoPoncho.value.length}} / 10</mat-hint>
                <mat-error>{{hasErrorFormControl(formulario.controls.ingrediente_ativo_laudo_produto_poncho)}}
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col-lg col-md">
              <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Correção i.a Poncho (%)</mat-label>
                <input matInput id="txtCorrecaoIaPoncho" #txtCorrecaoIaPoncho maxlength="10"
                  formControlName="correcao_ia_poncho" currencyMask
                  [options]="{ thousands: '.', decimal: ',', precision: 2, allowNegative: true  }"
                  (blur)="makeCalculationsII()" [class.InputBlockColor]="true" [readonly]="true">

                <i matSuffix class="{{iconDisableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}</mat-hint>
                <mat-hint align="end">{{txtCorrecaoIaPoncho.value.length}} / 10</mat-hint>
                <mat-error>{{hasErrorFormControl(formulario.controls.correcao_ia_poncho)}}
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col-lg col-md">
              <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Correção Perda Processo Poncho (%)</mat-label>
                <input matInput id="txtCorrecaoPerdaProcesso" #txtCorrecaoPerdaProcesso maxlength="10"
                  formControlName="correcao_perda_processo_poncho" [min]="0" [max]="5" currencyMask
                  [options]="{ thousands: '.', decimal: ',', precision: 1 }"
                  (blur)="[makeCalculations(), makeCalculationsII()]" [class.InputBlockColor]="isReadOnlyPoncho"
                  [readonly]="isReadOnlyPoncho">
                <i matSuffix class="{{iconEnableField}}" *ngIf="!isReadOnlyPoncho"></i>
                <i matSuffix class="{{iconDisableField}}" *ngIf="isReadOnlyPoncho"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}</mat-hint>
                <mat-hint align="end">{{txtCorrecaoPerdaProcesso.value.length}} / 10</mat-hint>
                <mat-error>{{hasErrorFormControl(formulario.controls.correcao_perda_processo_poncho)}}
                </mat-error>
              </mat-form-field>
            </div>


            <div class="col-lg col-md">
              <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}"
                [ngClass]='{"mat-form-field-invalid": formulario.controls.correcao_aplicacao_poncho.warning}'>
                <mat-label class="InputLabelColor">Correção Total Poncho (%)</mat-label>
                <input matInput id="txtCorrAplPoncho" #txtCorrAplPoncho maxlength="10"
                  formControlName="correcao_aplicacao_poncho" currencyMask
                  [options]="{ thousands: '.', decimal: ',', precision: 2, allowNegative: true  }" [readOnly]="true"
                  [class.InputBlockColor]="true" (blur)="makeCalculations()" (keyup)="makeCalculationsII()">
                <!-- <i matSuffix class="{{iconEnableField}}" *ngIf="!isReadOnlyPoncho"></i> -->
                <i matSuffix class="{{iconDisableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor"
                  *ngIf="!formulario.controls.correcao_aplicacao_poncho.warning">{{hintNumber}}</mat-hint>
                <mat-hint align="end">{{txtCorrAplPoncho.value.length}} / 10</mat-hint>
                <mat-hint align="start" *ngIf="formulario.controls.correcao_aplicacao_poncho.warning" class="mat-error">
                  Resultado é maior que 5
                </mat-hint>
                <mat-error
                  *ngIf="!formulario.controls.correcao_aplicacao_poncho.warning">{{hasErrorFormControl(formulario.controls.correcao_aplicacao_poncho)}}
                </mat-error>
              </mat-form-field>
            </div>
            <!-- <div class="col-lg col-md">
              <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Correção de Aplicação Cruiser (%)</mat-label>
                <input matInput id="txtCorrAplCruiser" #txtCorrAplCruiser maxlength="10"
                  formControlName="correcao_aplicacao_cruiser" currencyMask [readOnly]="isReadOnlyCruiser"
                  [class.InputBlockColor]="isReadOnlyCruiser" (blur)="makeCalculations()"
                  (keyup)="makeCalculationsII()">
                <i matSuffix class="{{iconEnableField}}" *ngIf="!isReadOnlyCruiser"></i>
                <i matSuffix class="{{iconDisableField}}" *ngIf="isReadOnlyCruiser"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}</mat-hint>
                <mat-hint align="end">{{txtCorrAplPoncho.value.length}} / 10</mat-hint>
                <mat-error>{{hasErrorFormControl(formulario.controls.correcao_aplicacao_cruiser)}}
                </mat-error>
              </mat-form-field>
            </div>-->
          </div>

          <div class="row pt-3">
            <div class="col-lg col-md">
              <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Ingrediente Ativo Laudo - Dermacor</mat-label>
                <input matInput id="txtIngredienteAtivoLaudoDemacor" #txtIngredienteAtivoLaudoDemacor maxlength="10"
                  [min]="40" [max]="60" formControlName="ingrediente_ativo_laudo_produto_dermacor" currencyMask
                  [options]="{ thousands: '.', decimal: ',', precision: 1 }" (blur)="makeCalculationsII()"
                  [readOnly]="isReadOnlyDermacor" [class.InputBlockColor]="isReadOnlyDermacor">

                <i matSuffix class="{{iconEnableField}}" *ngIf="!isReadOnlyDermacor"></i>
                <i matSuffix class="{{iconDisableField}}" *ngIf="isReadOnlyDermacor"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}</mat-hint>
                <mat-hint align="end">{{txtIngredienteAtivoLaudoDemacor.value.length}} / 10</mat-hint>
                <mat-error>{{hasErrorFormControl(formulario.controls.ingrediente_ativo_laudo_produto_dermacor)}}
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col-lg col-md">
              <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Correção i.a Dermacor (%)</mat-label>
                <input matInput id="txtCorrecaoIaDemacor" #txtCorrecaoIaDemacor maxlength="10"
                  formControlName="correcao_ia_dermacor" currencyMask
                  [options]="{ thousands: '.', decimal: ',', precision: 2, allowNegative: true  }"
                  (blur)="makeCalculationsII()" [readOnly]="true" [class.InputBlockColor]="true">
                <!-- <i matSuffix class="{{iconEnableField}}"></i> -->
                <i matSuffix class="{{iconDisableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}</mat-hint>
                <mat-hint align="end">{{txtCorrecaoIaDemacor.value.length}} / 10</mat-hint>
                <mat-error>{{hasErrorFormControl(formulario.controls.correcao_ia_dermacor)}}
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col-lg col-md">
              <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Correção Perda Processo - Dermacor (%)</mat-label>
                <input matInput id="txtCorrecaoPerdaProcessoDermacor" #txtCorrecaoPerdaProcessoDermacor maxlength="10"
                  formControlName="correcao_perda_processo_dermacor" [min]="0" [max]="5" currencyMask
                  [options]="{ thousands: '.', decimal: ',', precision: 1 }" (blur)="makeCalculationsII()"
                  [readOnly]="isReadOnlyDermacor" [class.InputBlockColor]="isReadOnlyDermacor">
                <i matSuffix class="{{iconEnableField}}" *ngIf="!isReadOnlyDermacor"></i>
                <i matSuffix class="{{iconDisableField}}" *ngIf="isReadOnlyDermacor"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}</mat-hint>
                <mat-hint align="end">{{txtCorrecaoPerdaProcessoDermacor.value.length}} / 10</mat-hint>
                <mat-error>{{hasErrorFormControl(formulario.controls.correcao_perda_processo_dermacor)}}
                </mat-error>
              </mat-form-field>
            </div>

            <div class="col-lg col-md">
              <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}"
                [ngClass]='{"mat-form-field-invalid": formulario.controls.correcao_aplicacao_dermacor.warning}'>
                <mat-label class="InputLabelColor">Correção Total Dermacor (%)</mat-label>
                <input matInput id="txtCorrAplDermacor" #txtCorrAplDermacor maxlength="10"
                  formControlName="correcao_aplicacao_dermacor" currencyMask
                  [options]="{ thousands: '.', decimal: ',', precision: 2, allowNegative: true  }" [readOnly]="true"
                  [class.InputBlockColor]="true" (blur)="makeCalculations()" (keyup)="makeCalculationsII()">
                <!-- <i matSuffix class="{{iconEnableField}}" *ngIf="!isReadOnlyDermacor"></i> -->
                <i matSuffix class="{{iconDisableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor"
                  *ngIf="!formulario.controls.correcao_aplicacao_poncho.warning">{{hintNumber}}</mat-hint>
                <mat-hint align="end">{{txtCorrAplDermacor.value.length}} / 10</mat-hint>

                <mat-hint align="start" *ngIf="formulario.controls.correcao_aplicacao_dermacor.warning"
                  class="mat-error">
                  Resultado é maior que 5
                </mat-hint>
                <mat-error
                  *ngIf="!formulario.controls.correcao_aplicacao_dermacor.warning">{{hasErrorFormControl(formulario.controls.correcao_aplicacao_dermacor)}}
                </mat-error>
              </mat-form-field>
            </div>
          </div>
          <div class="row pt-3">
            <div class="col-lg col-md">
              <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Correção Perda Processo - Redigo (%)</mat-label>
                <input matInput id="txtCorrecaoPerdaProcessoRedigo" #txtCorrecaoPerdaProcessoRedigo maxlength="10"
                  formControlName="correcao_perda_processo_redigo" [min]="0" [max]="5" currencyMask
                  [options]="{ thousands: '.', decimal: ',', precision: 1 }" (blur)="makeCalculationsII()"
                  [readOnly]="isReadOnlyRedigo" [class.InputBlockColor]="isReadOnlyRedigo">
                <i matSuffix class="{{iconEnableField}}" *ngIf="!isReadOnlyRedigo"></i>
                <i matSuffix class="{{iconDisableField}}" *ngIf="isReadOnlyRedigo"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}</mat-hint>
                <mat-hint align="end">{{txtCorrecaoPerdaProcessoRedigo.value.length}} / 10</mat-hint>
                <mat-error>{{hasErrorFormControl(formulario.controls.correcao_perda_processo_redigo)}}
                </mat-error>
              </mat-form-field>
            </div>

            <div class="col-lg col-md">
              <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}"
                [ngClass]='{"mat-form-field-invalid": formulario.controls.correcao_aplicacao_redigo.warning}'>
                <mat-label class="InputLabelColor">Correção Total Redigo (%)</mat-label>
                <input matInput id="txtCorrAplRedigo" #txtCorrAplRedigo maxlength="10"
                  formControlName="correcao_aplicacao_redigo" currencyMask
                  [options]="{ thousands: '.', decimal: ',', precision: 2, allowNegative: true  }" [readOnly]="true"
                  [class.InputBlockColor]="true" (blur)="makeCalculations()" (keyup)="makeCalculationsII()">
                <!-- <i matSuffix class="{{iconEnableField}}" *ngIf="!isReadOnlyRedigo"></i> -->
                <i matSuffix class="{{iconDisableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor"
                  *ngIf="!formulario.controls.correcao_aplicacao_poncho.warning">{{hintNumber}}</mat-hint>
                <mat-hint align="end">{{txtCorrAplRedigo.value.length}} / 10</mat-hint>
                <mat-hint align="start" *ngIf="formulario.controls.correcao_aplicacao_redigo.warning" class="mat-error">
                  Resultado é maior que 5
                </mat-hint>
                <mat-error
                  *ngIf="!formulario.controls.correcao_aplicacao_redigo.warning">{{hasErrorFormControl(formulario.controls.correcao_aplicacao_redigo)}}
                </mat-error>
              </mat-form-field>
            </div>


          </div>

          <div class="row pt-3">
            <!-- <div class="col-lg col-md">
              <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Ingrediente Ativo do Laudo do Produto (g/L) - Cruiser</mat-label>
                <input matInput id="txtIngAtivoLaudoProdCruiser" #txtIngAtivoLaudoProdCruiser maxlength="10"
                  formControlName="ingrediente_ativo_laudo_produto_cruiser" currencyMask [readOnly]="isReadOnlyCruiser"
                  [class.InputBlockColor]="isReadOnlyCruiser" [options]="{ thousands: '.', decimal: ',', precision: 0 }"
                  (blur)="makeCalculations()">
                <i matSuffix class="{{iconEnableField}}" *ngIf="!isReadOnlyCruiser"></i>
                <i matSuffix class="{{iconDisableField}}" *ngIf="isReadOnlyCruiser"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}</mat-hint>
                <mat-hint align="end">{{txtIngAtivoLaudoProdCruiser.value.length}} / 10</mat-hint>
                <mat-error>{{hasErrorFormControl(formulario.controls.ingrediente_ativo_laudo_produto_cruiser)}} 
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col-lg col-md">
              <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Ingrediente Ativo do Laudo do Produto (g/L) Redigo</mat-label>
                <input matInput id="txtIngAtivoLaudoProdRedigo" #txtIngAtivoLaudoProdRedigo maxlength="10"
                  formControlName="ingrediente_ativo_laudo_produto_redigo" currencyMask [readOnly]="isReadOnlyRedigo"
                  [class.InputBlockColor]="isReadOnlyRedigo" [options]="{ thousands: '.', decimal: ',', precision: 0 }"
                  (blur)="makeCalculations()">
                <i matSuffix class="{{iconEnableField}}" *ngIf="!isReadOnlyRedigo"></i>
                <i matSuffix class="{{iconDisableField}}" *ngIf="isReadOnlyRedigo"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}</mat-hint>
                <mat-hint align="end">{{txtIngAtivoLaudoProdRedigo.value.length}} / 10</mat-hint>
                <mat-error>{{hasErrorFormControl(formulario.controls.ingrediente_ativo_laudo_produto_redigo)}} 
                </mat-error>
              </mat-form-field>
            </div> -->

          </div>

          <!-- <div class="row pt-3">
            <div class="col-lg col-md">
              <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Correção Total</mat-label>
                <input matInput id="txtCorrecaoTotal" #txtCorrecaoTotal maxlength="10" formControlName="correcao_total"
                  currencyMask readonly class="InputBlockColor"
                  [options]="{ thousands: '.', decimal: ',', precision: 0 }" (blur)="makeCalculations()">
                <i matSuffix class="{{iconEnableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}</mat-hint>
                <mat-hint align="end">{{txtCorrecaoTotal.value.length}} / 10</mat-hint>
                <mat-error>{{hasErrorFormControl(formulario.controls.correcao_total)}}
                </mat-error>
              </mat-form-field>
            </div>
          </div> -->
        </mat-card-content>
      </form>
    </mat-card>
  </div>
</div>